import LiveScore from './livescore';

export default LiveScore;
